import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import SalesforceCloudOutlineJson from 'images/SalesforceCloudOutline.json';
export const SalesforceCloudOutline = (props) => React.createElement(Player, Object.assign({}, props, { autoplay: true, loop: true, src: SalesforceCloudOutlineJson }));
